import { VASTU_OUTSTATION } from "@/data/constants";

const GOLD = "#B89047";
const CHARCOAL = "#1A1A1A";
const OFF_WHITE = "#FDFCF8";
const BORDER = "#E5E0D8";

export default function VastuOutstationCards() {
  return (
    <div>
      <div data-testid="vastu-outstation-cards" className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {VASTU_OUTSTATION.map((card) => (
          <div key={card.id} data-testid={`vastu-outstation-${card.id}`} style={{ border: `1px solid ${BORDER}`, backgroundColor: OFF_WHITE, padding: "36px 32px" }}>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "0.58rem", letterSpacing: "0.18em", textTransform: "uppercase", color: "#8A8A8A", fontWeight: 600, marginBottom: "8px" }}>
              {card.location}
            </p>
            <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.5rem", fontWeight: 500, color: CHARCOAL, marginBottom: "6px" }}>
              {card.name}
            </h3>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "1.4rem", fontWeight: 700, color: GOLD, marginBottom: "2px" }}>
              {card.price}
              <span style={{ fontFamily: "'Outfit', sans-serif", fontSize: "0.75rem", fontWeight: 400, color: "#8A8A8A", marginLeft: "6px" }}>{card.unit}</span>
            </p>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "0.82rem", color: "#4A4A4A", lineHeight: 1.7, marginTop: "12px", marginBottom: "20px" }}>
              {card.description}
            </p>
            <div style={{ borderTop: `1px solid ${BORDER}`, paddingTop: "16px" }}>
              <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "0.58rem", letterSpacing: "0.15em", textTransform: "uppercase", color: GOLD, fontWeight: 600, marginBottom: "10px" }}>
                Additional Expenses (unless agreed otherwise)
              </p>
              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                {card.expenses.map((exp) => (
                  <div key={exp} style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <span style={{ width: "4px", height: "4px", backgroundColor: GOLD, borderRadius: "50%", flexShrink: 0 }} />
                    <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "0.8rem", color: "#4A4A4A" }}>{exp}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "0.78rem", color: "#8A8A8A", lineHeight: 1.7, marginTop: "16px", fontStyle: "italic" }}>
        Professional visit fees shown above are starting rates. Final fee depends on property size, scope, and duration. All travel, accommodation, local transport, visas, and documentation expenses are additional unless agreed otherwise.
      </p>
    </div>
  );
}
